module.exports = __webpack_public_path__ + "img/chimaybe.4d13e5f2.jpg";